//import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '@fancyapps/fancybox';

function FancyBox() {

    $().fancybox({});

    $('[data-video]').fancybox({
        'hideOnContentClick': true
    });

}

export default FancyBox;